<script>
function parseJsonResponse(res) {
  return res.text().then(function (text) {
    var data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      data = { success: false, message: text || "API response ไม่ถูกต้อง" };
    }
    if (!res.ok) {
      throw new Error(data.message || "Request failed");
    }
    return data;
  });
}

export default {
  name: "AdminSettings",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    var settings = (this.config && this.config.settings) || {};
    return {
      formTestTools: String(settings.form_test_tools || "0") === "1" ? "1" : "0",
      formTestFromDb: !!settings.form_test_tools_from_db,
      saving: false,
      alert: { type: "", message: "" },
    };
  },
  computed: {
    saveUrl: function () {
      return String((this.config && this.config.saveUrl) || "actions/admin/settings-save.php");
    },
  },
  methods: {
    applySettings: function (settings) {
      var s = settings && typeof settings === "object" ? settings : {};
      this.formTestTools = String(s.form_test_tools || "0") === "1" ? "1" : "0";
      this.formTestFromDb = !!s.form_test_tools_from_db;
    },
    save: function () {
      var self = this;
      this.saving = true;
      this.alert = { type: "", message: "" };
      var body = new FormData();
      body.append("section", "general");
      body.append("form_test_tools", this.formTestTools);
      fetch(this.saveUrl, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "บันทึกไม่สำเร็จ");
          }
          if (data.settings) {
            self.applySettings(data.settings);
          }
          self.alert = { type: "success", message: data.message || "บันทึกตั้งค่าระบบแล้ว" };
        })
        .catch(function (e) {
          self.alert = { type: "danger", message: e.message || "เกิดข้อผิดพลาด" };
        })
        .finally(function () {
          self.saving = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">ตั้งค่าระบบ</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">ผู้ดูแลระบบ</a></li>
              <li class="breadcrumb-item active">ตั้งค่าระบบ</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="alert.message" class="alert alert-dismissible fade show" :class="alert.type === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
      {{ alert.message }}
      <button type="button" class="btn-close" aria-label="Close" @click="alert.message = ''"></button>
    </div>

    <form autocomplete="off" @submit.prevent="save">
      <div class="row">
        <div class="col-xl-8">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title mb-0">โหมดทดสอบฟอร์ม</h4>
            </div>
            <div class="card-body">
              <p class="text-muted">ปุ่ม «เติมข้อมูลจำลอง» ในฟอร์มสมัครสาธารณะ เพิ่มสมาชิก และเพิ่มทายาท</p>
              <div class="form-check form-switch mb-3">
                <input id="mct-form-test-tools" v-model="formTestTools" class="form-check-input" type="checkbox" true-value="1" false-value="0">
                <label class="form-check-label" for="mct-form-test-tools">แสดงปุ่มเติมข้อมูลจำลอง</label>
              </div>
              <p v-if="!formTestFromDb" class="form-text mb-0">ยังไม่ได้บันทึกในฐานข้อมูล — ค่าที่เห็นมาจาก localhost / <code>?test=1</code> / env เมื่อกดบันทึก ค่านี้จะบังคับทั้งระบบ</p>
              <p v-else class="form-text mb-0">ค่านี้มาจากฐานข้อมูล และจะบังคับทั้งระบบ รวมถึงเครื่อง localhost</p>
            </div>
          </div>
          <button type="submit" class="btn btn-success" :disabled="saving">
            {{ saving ? "กำลังบันทึก..." : "บันทึกตั้งค่า" }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
